<template>
    <th @click="handleClick()" scope="col"
        :class="{'another-month': isAnotherMonth,
                 'absence': absence && !isAnotherMonth, 'chosen': chosen,
                 'today': today === date, 'disabled': isAnotherMonth || disabled}">
        <template>
            {{ getRepresentation }} <span class="week-day"> <sup>({{ getWeekday }})</sup></span>
        </template>
    </th>
</template>

<script>

    export default {
        name: "DayCalendar",
        props: {
            date: {
                type: String,
                required: true
            },
            isAnotherMonth: {
                type: Boolean,
                required: true
            },
            disabled: {
                type: Boolean,
                required: true
            },
            absence: {
                type: Boolean,
                required: true
            },
            resetFlag: {
                type: Boolean,
                required: true
            },
        },
        data() {
            return {
                chosen: false,
            }
        },
        methods: {
            handleClick: function () {
                if (!this.isAnotherMonth && !this.disabled) {
                    this.chosen = !this.chosen;
                    this.$emit(this.chosen ? 'add' : 'remove', {
                        date: this.date,
                        absence: this.absence
                    });
                }
            }
        },
        computed: {
            today() {
                return moment().format('YYYY-MM-DD');
            },
            weekend() {
                return moment(this.date).weekday() > 4;
            },
            getRepresentation() {
                return moment(this.date).format('DD.MM');
            },
            getWeekday() {
                return moment(this.date).format('dd');
            },
        },
        watch: {
            resetFlag() {
                this.chosen = false;
            },
            absence(newVal, oldVal) {
                if (newVal !== oldVal)
                    this.chosen = false;
            }
        }

    }
</script>
<style lang="scss" scoped>
    th {
        color: #fff;
        background: #3a3a3a;
        border-bottom-width: 1px;
    }
    .today {
        color: #ff6200 !important;
    }
    .chosen {
       background: #7ed654 !important;
    }
    .week-day {
        color: #eaeaea
    }
    .today .week-day {
        color: #ff6200;
    }
    .absence:not(.week-end) {
        position: relative;
        &:after {
            content: '';
            position: absolute;
            left: 10px;
            top: 16px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #7ed654;
        }        
    }
    .absence.week-end {
        background-color: #696868 !important;
    }
    th.disabled {
        background: #696868;
    }
    .week-end {
        background-color: #696868;
        color: #e8e8e8 !important;
    }
    th:not(.week-end):not(.disabled):hover {
        background: lighten(#3a3a3a, 10);
        cursor: pointer;
    }
    th.week-end:not(.disabled):hover {
        background: #8f8f8f !important;
        cursor: pointer;
    }

</style>


// WEBPACK FOOTER //
// DayCalendar.vue?aed8bc94